import { useAuthService } from '@vivli/core/infrastructure/hook';
import { IContextWrapper } from '@vivli/shared/infrastructure/interface';
import { AuthContext } from '@vivli/core/infrastructure/context';
import { IAuthContext } from '@vivli/core/infrastructure/interface';

export const PlatformAuthContextWrapper = ({ children }: IContextWrapper) => {
    const authService = useAuthService('test');

    const provider: IAuthContext = {
        authService
    };

    // Keep the app blank until the session decision resolves. A stale fresh session is redirected
    // to B2C logout while this gate is still closed, so no app content or overlay ever appears.
    return <AuthContext.Provider value={provider}>{authService.isSessionReady ? children : null}</AuthContext.Provider>;
};
